<template>
  <FreeBottomSheet :name="name" @onOpen="publicOfferData.fetchPublicOffer">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-base font-medium">
            {{ t('publicOffer.title') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div
        v-if="publicOfferData.isLoading.value"
        class="flex min-h-[80vh] items-center justify-center"
      >
        <FreeLoader />
      </div>
      <div
        v-else
        class="bg-background-neutral-secondary mx-4 space-y-2 rounded-2xl p-4"
      >
        <template
          v-for="(block, idx) in publicOfferData.offer.value?.body.blocks"
        >
          <HeaderBlock
            v-if="block.type === seo.types.SeoPageBlockType.header"
            :key="`${idx}h`"
            :text="block.data.text"
            :level="block.data.level"
          />
          <template v-else-if="block.type === seo.types.SeoPageBlockType.list">
            <ListBlock
              v-for="(item, itemIdx) in block.data.items"
              :key="`${itemIdx}l`"
              :list-style="block.data.style"
              :content="item.content"
              :items="item.items"
            />
          </template>
          <ParagraphBlock
            v-else-if="block.type === seo.types.SeoPageBlockType.paragraph"
            :key="`${idx}p`"
            :text="block.data.text"
          />
        </template>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeCloseButton,
    FreeHeader,
    FreeLoader,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import { publicOfferEntity, seo } from 'shared';

  import HeaderBlock from './HeaderBlock.vue';
  import ListBlock from './ListBlock.vue';
  import ParagraphBlock from './ParagraphBlock.vue';

  const props = defineProps<{
    name: string;
    fetchPublicOffer: () => Promise<seo.types.SeoPageQueryData>;
  }>();

  const { t } = useI18n();

  const publicOfferData = publicOfferEntity.model.usePublicOffer(
    props.fetchPublicOffer,
  );
</script>

<i18n src="../config/locales.json"></i18n>
